import { OPM } from '~types/index'

const getTurnOnOff = ({
  enabledOPM,
  OPM,
}: {
  enabledOPM: boolean
  OPM: OPM
}) => {
  const turnOn = enabledOPM && !OPM?.init
  const turnOff = !enabledOPM && OPM.init

  return { turnOn, turnOff }
}

export default getTurnOnOff
